import { hc } from 'hono/client';
import type { api } from '../../functions/api/[[route]]';

export type API = typeof api;

const API_BASE = import.meta.env.DEV 
  ? 'http://localhost:8787' 
  : '';

export const client = hc<API>(API_BASE, {
  headers: () => {
    const token = localStorage.getItem('token');
    return {
      Authorization: token ? `Bearer ${token}` : '',
    };
  },
});

// Helper functions
export async function login(username: string, password: string) {
  const res = await client.api.auth.login.$post({
    json: { username, password },
  });
  return res.json();
}

export async function getMe() {
  const res = await client.api.auth.me.$get();
  return res.json();
}

export async function getSantri() {
  const res = await client.api.santri.$get();
  return res.json();
}

export async function getKelompok() {
  const res = await client.api.kelompok.$get();
  return res.json();
}

export async function getDesa() {
  const res = await client.api.desa.$get();
  return res.json();
}

export async function uploadSantriPhoto(santriId: string, file: File) {
  const formData = new FormData();
  formData.append('file', file);
  
  const res = await fetch(`${API_BASE}/api/upload/santri-photo/${santriId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: formData,
  });
  return res.json();
}

export async function getSantriPhoto(santriId: string) {
  return `${API_BASE}/api/upload/santri-photo/${santriId}`;
}
